import { API_JWT_TOKEN_NAME, CALL_API } from '../middleware/api'
import { buildUrl } from '../utils/helpers'

export const ALL_METRICS_REQUEST = 'ALL_METRICS_REQUEST'
export const ALL_METRICS_SUCCESS = 'ALL_METRICS_SUCCESS'
export const ALL_METRICS_FAILURE = 'ALL_METRICS_FAILURE'
export const SET_METRICS_FILTER = 'SET_METRICS_FILTER'
export const CLEAR_METRICS_FILTER = 'CLEAR_METRICS_FILTER'

export function fetchAllMetrics(dateFrom, dateTo, business, country) {
  let queryParams = {}
  if (dateFrom) {
    queryParams = { ...queryParams, ...{ date_from: dateFrom } }
  }
  if (dateTo) {
    queryParams = { ...queryParams, ...{ date_to: dateTo } }
  }
  if (business) {
    queryParams = { ...queryParams, ...{ business } }
  }
  if (country) {
    queryParams = { ...queryParams, ...{ country } }
  }
  const endpoint = buildUrl('/api/transactions/metrics/', { ...queryParams })
  return {
    [CALL_API]: {
      endpoint,
      types: [ALL_METRICS_REQUEST, ALL_METRICS_SUCCESS, ALL_METRICS_FAILURE],
      method: 'GET',
      tokenType: API_JWT_TOKEN_NAME,
    },
  }
}

const setFilter = (content) => ({
  type: SET_METRICS_FILTER,
  content,
})

const clearFilter = () => ({
  type: CLEAR_METRICS_FILTER,
})

export const setMetricsFilter = (content) => (dispatch) => dispatch(setFilter(content))

export const clearMetricsFilter = () => (dispatch) => dispatch(clearFilter())
